export default "__VITE_ASSET__Dwt7Y_0$__"